/**
 * Owner: Masa Bayu
 * File: qx-taxonomy.ts
 * Date:Time: 2026-10-19 11:40
 * Description: §405 — punca tunggal taksonomi QX (36 kategori utama +
 *   subkategori, id stabil bertitik). API carian nama mengikut bahasa +
 *   pengesah id untuk qxread, qxp-hub dan qxwriter.
 */
import { QX_TAXONOMY_DATA_A } from './qx-taxonomy-data-a.js';
import { QX_TAXONOMY_DATA_B } from './qx-taxonomy-data-b.js';
/** §468l: `alamtologi` dipin di kedudukan #1; baki disusun A→Z ikut label `en`. */
const QX_PINNED_FIRST_CATEGORY_ID = 'alamtologi';
function byPinnedThenAlphabet(a, b) {
    if (a.id === QX_PINNED_FIRST_CATEGORY_ID)
        return b.id === a.id ? 0 : -1;
    if (b.id === QX_PINNED_FIRST_CATEGORY_ID)
        return 1;
    return a.en.localeCompare(b.en, 'en');
}
export const QX_TAXONOMY = Object.freeze([...QX_TAXONOMY_DATA_A, ...QX_TAXONOMY_DATA_B].sort(byPinnedThenAlphabet));
export const QX_MAIN_CATEGORY_IDS = Object.freeze(QX_TAXONOMY.map((category) => category.id));
const MAIN_BY_ID = new Map(QX_TAXONOMY.map((category) => [category.id, category]));
const SUB_BY_ID = new Map(QX_TAXONOMY.flatMap((main) => main.subcategories.map((sub) => [sub.id, { main, sub }])));
export function isQxMainCategoryId(value) {
    return MAIN_BY_ID.has(value);
}
export function qxMainCategoryById(id) {
    return MAIN_BY_ID.get(id);
}
export function qxSubcategoryById(id) {
    return SUB_BY_ID.get(id);
}
export function qxSubcategoriesOf(id) {
    return qxMainCategoryById(id)?.subcategories ?? [];
}
/** Nama kategori utama ATAU subkategori (id bertitik); id dikembalikan jika tak diketahui. */
export function qxCategoryName(id, language) {
    const main = MAIN_BY_ID.get(id);
    if (main !== undefined) {
        return language === 'ms' ? main.ms : main.en;
    }
    const hit = SUB_BY_ID.get(id);
    if (hit !== undefined) {
        return language === 'ms' ? hit.sub.ms : hit.sub.en;
    }
    return id;
}
/** Ibu (kategori utama) bagi sesuatu id subkategori; undefined jika bukan sub. */
export function qxParentOfSubcategory(id) {
    return SUB_BY_ID.get(id)?.main.id;
}
/** Semua id subkategori milik satu kategori utama. */
export function qxSubcategoryIdsOf(id) {
    return qxSubcategoriesOf(id).map((sub) => sub.id);
}
export function isQxSubcategoryId(value) {
    return SUB_BY_ID.has(value);
}
//# sourceMappingURL=qx-taxonomy.js.map